<template>
  <div>
    <el-form-item label="音频内容:">
      <AppSsmlEditor
          ref="audioTextEdit"
          :type="'audioText'"
          :audioText="formData.lessonContentTemplate.material.audioText"
          @handleChangeTitleAudio="handleChangeTitleAudio"
          :showForRead="formData.addType=='view'"
      ></AppSsmlEditor>
    </el-form-item>
    <div class="changeTitleTypeBox">
      <div>
        <span>声音属性： </span>
        <el-radio-group v-model="formData.lessonContentTemplate.material.voice" :disabled="formData.addType=='view'">
          <el-radio
              v-for="item in humanOption"
              :key="item.value"
              :label="item.value"
              :disabled="creatAudioLoading"
          >{{ item.label }}
          </el-radio>
        </el-radio-group>
        <div>
          <div style="margin-top: 15px; margin-bottom: 15px">
            <span>播放速度： </span>
            <el-radio-group
                v-model="formData.lessonContentTemplate.material.speechRate"
                :disabled="formData.addType=='view'"
            >
              <el-radio
                  v-for="item in rateArr"
                  :key="item.value"
                  :label="item.value"
                  :disabled="creatAudioLoading"
              >{{ item.label }}
              </el-radio>
            </el-radio-group>
          </div>
          <div
              v-if="formData.lessonContentTemplate.material.materialUrl"
              style="
              display: flex;
              justify-content: flex-start;
              align-items: center;
            "
          >
            <div>点击试听:</div>
            <div>
              <audio
                  :src="formData.lessonContentTemplate.material.materialUrl"
                  :loop="false"
                  controls
                  preload="auto"
                  controlsList="nodownload noplaybackrate"
                  ref="audioRef"
              ></audio>
            </div>
            <div>
              <el-button
                  size="mini"
                  type="primary"
                  @click="handleDeleteTitleAudio"
                  :disabled="formData.addType=='view'"
              >清除音频
              </el-button>
            </div>
          </div>
        </div>
      </div>
      <div style="display: flex;height: 30px;">
        <el-button size="mini" type="primary" plain @click="handlePickTextMaterial"
                   :disabled="formData.addType=='view'"
        >素材库
        </el-button>
        <el-button size="mini" type="primary" @click="handleTitleAudioPolyPhone"
                   :disabled="formData.addType=='view'"
        >多音字
        </el-button>
        <el-button
            size="mini"
            type="primary"
            :loading="creatAudioLoading"
            @click="handleTitleAudio"
            :disabled="formData.addType=='view'"
        >生成音频
        </el-button>
      </div>
    </div>
    <div class="unShowStar">
      <el-form-item
          label="展示文字:"
          prop="lessonContentTemplate.material.displayAudioText"
      >
        <el-input
            type="textarea"
            placeholder="不得超过1000字"
            v-model="formData.lessonContentTemplate.material.displayAudioText"
            :disabled="formData.addType=='view'"
        ></el-input>
      </el-form-item>
    </div>
    <div style="text-align: right">
      <el-checkbox-group v-model="markDownCheckBoxVal" @change="handleMarkDown" :disabled="formData.addType=='view'">
        <el-checkbox
            v-model="formData.lessonContentTemplate.material.markFlag"
            :checked="formData.lessonContentTemplate.material.markFlag === 1"
            :disabled="
            formData.lessonContentTemplate.material.displayAudioText &&
            formData.lessonContentTemplate.material.displayAudioText.trim()
              .length < 1
          "
            label="知识点回顾"
            size="mini"
        ></el-checkbox>
      </el-checkbox-group>
    </div>

    <CorrectPolyPhoneModal
        ref="CorrectPolyPhoneModal"
        @refreshInputVal="refreshInputVal"
        :input-val-arr="inputValArr"
    ></CorrectPolyPhoneModal>
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import AppSsmlEditor from "./../SsmlEditor.vue";
import CorrectPolyPhoneModal from "./../CorrectPolyPhoneModal.vue";
import MaterialPicker from "@/pages/MaterialCenter/components/MaterialPicker.vue";

export default {
  name: "AudioText",
  props: {
    formData: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  components: {MaterialPicker, AppSsmlEditor, CorrectPolyPhoneModal},
  data() {
    return {
      inputValArr: [],
      //音频讲解
      humanOption: [
        {
          label: "老师",
          value: "zhiyuan",
        },
        {
          label: "学生",
          value: "zhigui",
        },
        {
          label: "标准女生",
          value: "sijia",
        },
        {
          label: "沉稳男生",
          value: "stanley",
        },
      ],
      rateArr: [
        {
          label: "慢",
          value: 0.8,
        },
        {
          label: "正常",
          value: 1.0,
        },
        {
          label: "快",
          value: 1.2,
        },
      ],
      materialType: "text",
      titleAudioSrc: "",
      creatAudioLoading: false,
      markDownCheckBoxVal: false,
    };
  },
  computed: {
    ...mapState("courseCenter", ["audioDetail"]),
  },
  methods: {
    ...mapMutations("courseCenter", ["setData"]),
    ...mapActions("courseCenter", ["getAudioUrl"]),
    // 解析为ssml文本，生成音频
    creatSsmlText(val) {
      const characterArr = this.convertToObjects(val);
      if (characterArr.length < 1) {
        return "";
      }
      const ssmlText = characterArr
          .map((item) => {
            if (item.pinyin !== "") {
              return `<phoneme alphabet='py' ph='${item.pinyin}'>${item.cha}</phoneme>`;
            } else {
              return item.cha;
            }
          })
          .join("");
      return "<speak>" + ssmlText + "</speak>";
    },
    // 多音字不可编辑部分
    disabledEdit() {
      let paragraphs = document.querySelectorAll("p");
      paragraphs.forEach(function (paragraph) {
        let strongArr = paragraph.querySelectorAll("strong");
        strongArr.forEach(function (strong) {
          if (getComputedStyle(strong).color === "rgb(16, 104, 156)") {
            strong.setAttribute("contenteditable", "false");
          }
        });
      });
    },

    // 选择多音字发音弹框确定按钮传过来的富文本编辑器回显inputVal
    refreshInputVal(audioText) {
      if (this.type === "audioText") {
        this.formData.lessonContentTemplate.material.audioText = audioText;
        this.$refs.audioTextEdit.blurEditor();
      }
      if (this.type === "question") {
        this.formData.lessonContentTemplate.materials[0].audioText = audioText;
        this.$refs.questionEdit.blurEditor();
      }
      if (this.type === "explain") {
        this.formData.lessonContentTemplate.materials[3].audioText = audioText;
        this.$refs.explainEdit.blurEditor();
      }
      this.$nextTick(() => {
        this.disabledEdit();
      });
    },
    // 返回纯文本数组
    convertToObjects(inputVal) {
      const objects = [];
      if (!inputVal) {
        return objects;
      }
      const regex = /(<strong.*?>.*?<\/strong>)|./g;
      const result = inputVal.match(regex);
      var newResult = [];
      for (let i = 0; i < result.length; i++) {
        if (result[i].trim().length > 1) {
          if (!result[i].includes("color: rgb(16, 104, 156)")) {
            const div = document.createElement("div");
            div.innerHTML = result[i];
            let text = div.textContent || div.innerText;
            newResult.push(text);
          } else {
            const div = document.createElement("div");
            div.innerHTML = result[i];
            let text = div.textContent || div.innerText;
            newResult.push("{{{" + text + "}}}");
          }
        } else {
          newResult.push(result[i]);
        }
      }
      const str = newResult.join("");
      const div = document.createElement("div");
      div.innerHTML = str;
      let newStr = div.textContent || div.innerText;
      const regex2 = /({{{.*?}}})|./g;
      const result2 = newStr.match(regex2);
      for (let i = 0; i < result2.length; i++) {
        const item = result2[i];
        if (item.length > 1) {
          const regex = /\{\{\{(.+?)\}\}\}/g;
          const match = item.replace(regex, "$1");
          if (match && match.length >= 2) {
            const extractedText = match.trim();
            const cha = extractedText.split("]")[1];
            const pinyin = extractedText.split("]")[0].split("[")[1];
            objects.push({cha: cha, pinyin: pinyin});
          }
        } else {
          objects.push({cha: item, pinyin: ""});
        }
      }
      return objects;
    },
    //题干转音频
    handleChangeTitleAudio(val) {
      this.formData.lessonContentTemplate.material.audioText = val;
    },
    // 多音字弹框
    handleTitleAudioPolyPhone() {
      this.type = "audioText";
      const inputVal = this.formData.lessonContentTemplate.material.audioText;
      this.inputValArr = this.convertToObjects(inputVal);
      console.log(this.inputValArr)
      if (this.inputValArr.length < 1 || this.inputValArr.length > 300) {
        return;
      }
      this.$refs.CorrectPolyPhoneModal.visible = true;
      // this.setData({key: "polyPhoneModalVisible", value: true});
    },
    handlePickTextMaterial() {
      this.$emit("onOpenPickTextMaterialModal");
    },
    // 生成音频
    async handleTitleAudio() {
      console.log("handleTitleAudio");
      const inputVal = this.formData.lessonContentTemplate.material.audioText;
      this.inputValArr = this.convertToObjects(inputVal);
      if (this.inputValArr.length > 300) {
        return;
      }
      this.creatAudioLoading = true;
      if (!this.formData.lessonContentTemplate.material.audioText) {
        this.$message.warning("当前题干为空,不支持转音频");
        this.creatAudioLoading = false;
        return;
      }
      this.formData.lessonContentTemplate.material.audioSsmlText =
          this.creatSsmlText(
              this.formData.lessonContentTemplate.material.audioText
          );
      if (!this.formData.lessonContentTemplate.material.audioSsmlText) {
        this.$message.warning("当前题干为空,不支持转音频");
        this.creatAudioLoading = false;
        return;
      }
      await this.getAudioUrl({
        text: this.formData.lessonContentTemplate.material.audioSsmlText,
        speechRate: this.formData.lessonContentTemplate.material.speechRate,
        voice: this.formData.lessonContentTemplate.material.voice,
      });
      // 媒体名称
      this.formData.lessonContentTemplate.material.filename =
          this.audioDetail.filename;
      // 媒体ID
      this.formData.lessonContentTemplate.material.materialId =
          this.audioDetail.id;
      // 音频时长
      const audio = document.createElement("video");
      audio.src = this.audioDetail.url;
      audio.addEventListener("loadedmetadata", () => {
        if (Math.floor(audio.duration) === 0) {
          this.formData.lessonContentTemplate.material.duration = 1;
        } else {
          this.formData.lessonContentTemplate.material.duration = Math.floor(
              audio.duration
          );
        }
      });
      // 媒体类型
      this.formData.lessonContentTemplate.material.type =
          this.audioDetail.mimeType;
      // 媒体url
      this.formData.lessonContentTemplate.material.materialUrl =
          this.audioDetail.url;
      this.creatAudioLoading = false;
    },
    handleDeleteTitleAudio() {
      this.$confirm("请确认是否要清除当前音频内容?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(async () => {
            this.formData.lessonContentTemplate.material.materialUrl = "";
            this.formData.lessonContentTemplate.material.materialId = null;
            this.formData.lessonContentTemplate.material.duration = null;
            this.formData.lessonContentTemplate.material.filename = "";
            this.formData.lessonContentTemplate.material.audioText = "";
            this.formData.lessonContentTemplate.material.audioSsmlText = "";
            if (this.formData.role === "学生") {
              this.defaultVoiceMethod("zhigui");
            } else {
              this.defaultVoiceMethod("zhiyuan");
            }
          })
          .catch(() => {
          });
    },
    handleMarkDown(val) {
      if (val) {
        this.formData.lessonContentTemplate.material.markFlag = 1;
      } else {
        this.formData.lessonContentTemplate.material.markFlag = 0;
      }
    },
    // 声音属性默方法
    defaultVoiceMethod(voice) {
      if (this.isSituational) {
        this.formData.lessonContentTemplate.materials[3].voice = voice;
        this.formData.lessonContentTemplate.materials[3].speechRate = 1.0;
      }
      if (
          this.formData.type === "select" ||
          this.formData.type === "multipleSelect" ||
          this.formData.type === "judge" ||
          this.formData.type === "sort" ||
          this.formData.type === "text" ||
          this.formData.type === "imageSelect"
      ) {
        this.formData.lessonContentTemplate.materials[0].voice = voice;
        this.formData.lessonContentTemplate.materials[0].speechRate = 1.0;
      }
      if (this.formData.type === "audioText") {
        this.formData.lessonContentTemplate.material.voice = voice;
        this.formData.lessonContentTemplate.material.speechRate = 1.0;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
//题干转音频
.changeTitleTypeBox {
  margin-left: 90px;
  margin-top: 20px;
  margin-bottom: 10px;
  display: block;
  justify-content: space-between;
}
</style>
